// Vue 3 dropped the `new Vue()` as-a-bare-event-emitter trick (no more
// $on/$off/$emit on plain instances), so this now reuses the same mitt bus
// the rest of the app uses as its global event bus. Note the API is
// `.on()`/`.emit()`, not `.$on()`/`.$emit()` - see Notifications.vue and
// ./index.js for the call sites that had to change along with this.
import { bus } from '@/modules/bus'

export const events = bus
